/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Redirect } from 'react-router-dom';
import { paths } from 'routes/paths';
import useTasksFlags from 'hooks/useTasksFlags';

const withTasksDecommission = WrappedComponent => {
  const TasksDecommissionGuard = props => {
    const { isTasksDisabled } = useTasksFlags();

    if (isTasksDisabled) {
      return <Redirect to={paths.applications} />;
    }

    return <WrappedComponent {...props} />;
  };

  return TasksDecommissionGuard;
};

export default withTasksDecommission;
